import { combineReducers } from 'redux'
import auth from './auth.reducer'
import { alerts, alert } from './alerts.reducer'
import { messages, message } from './messages.reducer'
import persons from './persons.reducer'
import {
  guests,
  includeReservationPartyList,
  guestAttribute,
  guestInformation,
  guestHistory,
  minorError,
  includeReservationGuests,
  stateroomGuests,
  stateroomGuestsList,
  reservationParty,
  travelParty,
  stateroomParty,
  guestIAMPersonDetail,
  reservationGuests,
  reservationExceptionGuests,
  voyageWithParty
} from './guests.reducer'
import crew, { crewManagementApplications } from './crew.reducer'
import { visitors, visitor, visitorsImportStatus, visitorRules } from './visitors.reducer'
import { dashboard, calendarData } from './dashboard.reducer'
import cabins from './cabins.reducer'
import {
  masterBoardingSlots,
  defaultMasterDataList
} from './masterBoardingSlots.reducer'

import settings from './settings.reducer'
import startup from './startup.reducer'
import { masterdata, ships, vipIcons } from './masterdata.reducer'
import notification from './notification.reducer'
import { voyage, isPastVoyage, pastVoyageList } from './voyage.reducer'
import loader from './loader.reducer'
import { ipmDuties, ipmGroup } from './ipm.reducer'
import { slots, boardingPattern, guestCount } from './slots.reducer'
import {
  searchResults,
  searchStateroomGuestsResult,
  getOccupiedGuestsList,
  getGlobalSearchRolesList
} from './search.reducer'
import ship from './ship.reducer'
import isShore from './mode.reducer'
import resources from './resources.reducer'
import {
  stateroom,
  searchedStateroom,
  stateroomCategory,
  stateroomCapacity,
  stateroomStatus
} from './stateroom.reducer'
import guestType from './guestType.reducer'
import newguest from './newguest.reducer'
import reservationCreation from './reservationCreation.reducer'
import {
  movementReports,
  locationReports,
  missingPictureReports,
  expiredCardReports,
  checkedInNotOnboardReports,
  notCheckedInOnboardReports,
  visitorOnboardReports,
  wearableAssignedReports,
  debarkedOnboardedSummaryReports,
  ipmReports,
  cbpReportsGuests,
  sailorLocationHistoryReports,
  sailorBoardingSlotHistoryReports,
  inActiveVisitorReports,
  sailorFlightDetailsReports,
  crewLocationHistoryReports,
  visitorLocationHistoryReports,
  cbpReportsCrew,
  reservationsMissingInFidelioReports,
  alertReports,
  boardingSlotReports,
  documentTypeBreakdownReports,
  documentWiseSailors,
  sailorNationalityReports,
  nationalityWiseSailors
} from './reports.reducer'
import { broadcastMessages } from './broadcast.reducer'
import port from './port.reducer'
import { sailorAshoreVisitReports } from './sailorAshoreVisit.reducer'
import {
  existingEnoadComparisonResult,
  generatedEnoadComparisonResult,
  generatedEnoadBatchMsg,
  selectedPort,
  voyageLegs
} from './cbpDashboard.reducer'

export default combineReducers({
  auth,
  startup,
  masterdata,
  ships,
  alerts,
  messages,
  persons,
  searchResults,
  guestDetails: {},
  guests,
  includeReservationGuests,
  crew,
  crewManagementApplications,
  visitors,
  dashboard,
  cabins,
  settings,
  visitor,
  visitorsImportStatus,
  notification,
  voyage,
  loader,
  stateroomStatus,
  alert,
  message,
  calendarData,
  ipmDuties,
  slots,
  ship,
  isShore,
  resources,
  movementReports,
  locationReports,
  sailorLocationHistoryReports,
  sailorBoardingSlotHistoryReports,
  inActiveVisitorReports,
  sailorFlightDetailsReports,
  crewLocationHistoryReports,
  visitorLocationHistoryReports,
  missingPictureReports,
  expiredCardReports,
  checkedInNotOnboardReports,
  notCheckedInOnboardReports,
  visitorOnboardReports,
  wearableAssignedReports,
  reservationExceptionGuests,
  debarkedOnboardedSummaryReports,
  reservationsMissingInFidelioReports,
  boardingSlotReports,
  documentTypeBreakdownReports,
  documentWiseSailors,
  sailorNationalityReports,
  nationalityWiseSailors,
  ipmReports,
  cbpReportsGuests,
  cbpReportsCrew,
  isPastVoyage,
  broadcastMessages,
  stateroom,
  guestIAMPersonDetail,
  guestCount,
  reservationGuests,
  includeReservationPartyList,
  searchedStateroom,
  guestType,
  newguest,
  stateroomCategory,
  reservationCreation,
  stateroomGuests,
  stateroomCapacity,
  reservationParty,
  stateroomParty,
  voyageWithParty,
  travelParty,
  stateroomGuestsList,
  searchStateroomGuestsResult,
  boardingPattern,
  guestInformation,
  guestHistory,
  pastVoyageList,
  minorError,
  getOccupiedGuestsList,
  masterBoardingSlots,
  getGlobalSearchRolesList,
  guestAttribute,
  alertReports,
  defaultMasterDataList,
  ipmGroup,
  vipIcons,
  port,
  sailorAshoreVisitReports,
  generatedEnoadBatchMsg,
  existingEnoadComparisonResult,
  generatedEnoadComparisonResult,
  selectedPort,
  voyageLegs,
  visitorRules
})
